import { isPlainObject } from './isPlainObject';

export function filteredNullFromResponse(data: any) {
  if (data === null) {
    return undefined;
  }

  if (isPlainObject(data)) {
    return Object.entries(data).reduce((acc: any, [key, value]) => {
      acc[key] = filteredNullFromResponse(value);
      return acc;
    }, {});
  }

  return data;

}

